import { useEffect, useState } from "react";
// import axios from 'axios';
import _ from "lodash";
import { connect } from "react-redux";
import HoursUnder from "./HoursUnder";

import { Actions as ALLOWANCEACTIONS } from "../../store/actions/allowanceActions";
import { Actions as INVITE_ACTIONS } from "../../store/actions/employeeActions";
import { Actions as ACTIONS } from "../../store/actions/leaveActions";
import { Actions as PAYMENTACTIONS } from "../../store/actions/paymentActions";
import { Actions as PAYROLL_ACTIONS } from "../../store/actions/payrollActions";

import Tooltip from "@/tooltip";
import { ArrowUpTrayIcon, BanknotesIcon, ClockIcon, DocumentArrowDownIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useParams } from "react-router-dom";
import Spinner from "../common/Spinner";
import apiURL from "../../store/actions/apiURL";
import DownloadAllowanceTemplate from "./tools/DownloadAllowanceTemplate";

const Payroll = ({
	allowanceUploadErrors,
	allowanceUploadProgress,
	leaveGetBalances,
	leaveBalances,
	showPayTerminatedEmployeeModal,
	showInviteEmployeeModal,
	processingTimesheets,
	processedTimesheets,
	processTimesheets,
	clearProcessTimesheets,
	getPaymentStats,
	payPeriodDetails,
	payrollGetPayPeriod,
	updatingPayPeriod,
	org,
	uploadAllowanceModal,
	isDemo,
	payrollPage,
	jurisdiction,
	canProcessTimesheets,
}) => {
	const [employees, setEmployees] = useState(false);
	const [employeeByReference, setEmployeeByReference] = useState(false);

	// ensure if monthly this is changed
	const [isMonthly, setIsMonthly] = useState(true);
	const [isWeekly, setIsWeekly] = useState(true);

	const [submitted, setSubmitted] = useState(false);
	const [loaded, setLoaded] = useState(false);

	const presetData = [];

	// useEffect(() => {
	//   if (payPeriodDetails && payPeriodDetails.id && payPeriodDetails.periodEnd){
	//     let until = payPeriodDetails.leaveCutOff || payPeriodDetails.periodEnd;
	//     if (until){
	//       leaveGetBalances(until)
	//     }
	//   }
	// },[payPeriodDetails && payPeriodDetails.id && payPeriodDetails.periodEnd]);

	useEffect(() => {
		console.log("starting to obtain Data");

		if (!loaded) {
			// set loaded right away to avoid a re-trigger

			// clear any previous data
			localStorage.setItem("timesheetUnderHours", JSON.stringify({}));

			const paths = ["/settings/employees", "/settings/timesheet-rules"];

			Promise.all(
				paths.map(
					(path) =>
						fetch(apiURL + path, {
							credentials: "include",
							method: "GET",
							headers: {
								"Accept": "application/json",
								"Content-Type": "application/json",
							},
						}).then((response) => response.json()),
					// .catch(logError)
				),
			).then((data) => {
				// do something with the data
				console.log("data recieved", data);

				setLoaded(true);

				data[0] && data[0].employees && setEmployees(data[0].employees);

				const newEmployeeByReference = {};

				data[0] &&
					data[0].employees &&
					data[0].employees.map((employee) => {
						if (employee.id) {
							newEmployeeByReference[employee.id] = employee;
						}
					});

				// use Monthly Hours if Hours in Month or 173.33 Reference
				const needsMonthlyHours =
					(data && data[1] && _.find(data[1].rules, { rules: { parts: [{ type: "Hours in Month" }] } })) ||
					_.find(data[1].rules, { rules: { parts: [{ value: "173.33" }] } });
				const needsWeeklyHours =
					data &&
					data[1] &&
					(_.find(data[1].rules, { rules: { parts: [{ type: "Hours in Week" }] } }) ||
						_.find(data[1].rules, { rules: { parts: [{ type: "Basic Hours in Week" }] } }));
				console.log("isMonthly", needsMonthlyHours);
				setIsMonthly(needsMonthlyHours);
				setIsWeekly(needsWeeklyHours);

				console.log("employeeByReference", newEmployeeByReference, data[0].employees);

				newEmployeeByReference && setEmployeeByReference(newEmployeeByReference);
			});

			// payment stats used to check how many credits before sending conclude command
			getPaymentStats();
		}
	}, [org]);

	const modalStyle = {
		position: "fixed",
		width: "90%",
		height: "90%",
		top: "50%",
		left: "50%",
		transform: "translate(-50%,-50%)",
		background: "#fff",
		zIndex: "999997", //under the get in touch icon
		padding: "20px",
		overflow: "scroll",
		boxShadow: "#000 0px 0px 170px",
	};

	const processingOverlayStyle = {
		position: "fixed",
		width: "100%",
		height: "100%",
		top: "0",
		left: "0",
		background: "rgba(0,0,0,.75)",
		zIndex: 9999,
	};

	const close = () => clearProcessTimesheets();

	const disabled = processingTimesheets || submitted || allowanceUploadProgress;

	return (
		<div>
			{processedTimesheets && (
				<div>
					<div
						style={processingOverlayStyle}
						onClick={close}
					></div>
					<div style={modalStyle}>
						<div
							style={{
								position: "absolute",
								top: "5px",
								right: "5px",
								padding: "5px",
								cursor: "pointer",
							}}
							onClick={close}
						>
							<XMarkIcon className="h-5 w-5 mr-3 text-black" />
						</div>

						<HoursUnder
							data={processedTimesheets}
							employees={employees}
							employeeByReference={employeeByReference}
							leaveBalances={leaveBalances}
							isMonthly={isMonthly}
							isWeekly={isWeekly}
							setSubmitted={setSubmitted}
							close={close}
						/>

						<div className="clearfix" />
					</div>
				</div>
			)}

			<div>
				<div
					className="form-material pull-left"
					style={{ width: "max-content" }}
				>
					<label>AccuPay™</label>
					<button
						className="btn btn-success"
						disabled={!canProcessTimesheets && !isDemo}
						onClick={() => {
							if (!canProcessTimesheets && !isDemo) return;
							processTimesheets(true);
						}}
					>
						<Tooltip
							content="This feature is not available on your plan."
							isOpen={!canProcessTimesheets && !isDemo ? undefined : false}
						>
							<ClockIcon
								className="h-7 w-7"
								style={{
									display: "inline",
									verticalAlign: "text-top",
								}}
							/>
							&nbsp; Process Timesheets
							{processingTimesheets && (
								<Spinner
									style={{ width: "2rem", height: "2rem", verticalAlign: "middle" }}
									className="animate-spin -ml-1 mr-3 h-5 w-5 text-success"
								/>
							)}
						</Tooltip>
					</button>
				</div>
				<div
					className="form-material pull-right"
					style={{ width: "max-content", justifySelf: "flex-end" }}
				>
					<button
						className="btn btn-default"
						disabled={disabled}
						onClick={showPayTerminatedEmployeeModal}
					>
						<BanknotesIcon
							className="h-7 w-7"
							style={{
								display: "inline",
								verticalAlign: "text-top",
							}}
						/>
						&nbsp; Pay Terminated Employee
					</button>
				</div>
				<div
					className="form-material pull-right"
					style={{ width: "max-content" }}
				>
					<div className="btn-group">
						<DownloadAllowanceTemplate
							small
							disabled={disabled}
						/>
						<button
							className="btn btn-default"
							style={{ marginRight: "0.5rem" }}
							onClick={() => uploadAllowanceModal()}
							disabled={disabled}
						>
							<ArrowUpTrayIcon
								className="h-7 w-7"
								style={{
									display: "inline",
									verticalAlign: "text-top",
								}}
							/>
							&nbsp; Upload {jurisdiction == "UK" ? "Pay Items" : "Allowances"}
						</button>
					</div>
				</div>
				<div className="clearfix" />
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		...state.leave,
		payrollPage: state.payroll?.payrollPage,
		payPeriodDetails: state.payroll?.payPeriodDetails,
		updatingPayPeriod: state.payroll.updatingPayPeriod,
		processingTimesheets: state.payroll.processingTimesheets,
		processedTimesheets: state.payroll.processedTimesheets,
		org: state?.company?.settings?.org,
		isDemo: state?.company?.settings?.isDemo,
		jurisdiction: state.company?.settings?.jurisdiction,
		canProcessTimesheets: state.permissions?.plan?.processTimesheets,
	};
};

const mapDispatchToProps = (dispatch) => ({
	leaveGetBalances: (until) => dispatch(ACTIONS.leaveGetBalances(until)),
	showPayTerminatedEmployeeModal: () => dispatch(PAYROLL_ACTIONS.payTerminatedEmployeeModal(true)),
	processTimesheets: () => dispatch(PAYROLL_ACTIONS.processTimesheets(true)),
	clearProcessTimesheets: () => dispatch(PAYROLL_ACTIONS.clearProcessTimesheets()),
	uploadAllowanceModal: () => dispatch(PAYROLL_ACTIONS.uploadAllowanceModal(true)),
	showInviteEmployeeModal: () => dispatch(INVITE_ACTIONS.showInviteEmployeeModal(true)),
	getPaymentStats: () => dispatch(PAYMENTACTIONS.getPaymentStats()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);
